<template>
  <div class="view view_nopassword">
    <h1>{{ $t("noPassword.heading") }}</h1>
    <p>
      {{ $t("noPassword.cantBeOpenedWithout") }}
    </p>
    <p>
      {{ $t("noPassword.passwordsNotSaved") }}
    </p>
    <i18n-t keypath="noPassword.openOther" tag="p" scope="global">
      <a :href="platformUrl">{{ platformUrl }}</a>
    </i18n-t>
  </div>
</template>

<script setup lang="ts">
import envVars from "@/helpers/Env";

const platformUrl = envVars.platformUrl;
</script>

<style lang="scss">
.view_nopassword {
  padding: 3rem;
  background-color: var(--color-action);
  color: var(--color-action-contrast);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  a {
    color: var(--color-action-contrast);
  }
}
</style>
